// extracted by mini-css-extract-plugin
export default {"altText":"dhis__altText--d910d"};